import React from 'react'
import hlLockup from '../../images/landing/hl-lockup.svg'
import hlLockupFooter from '../../images/landing/hl-lockup-footer.svg'
import {landingPath} from './constants'

const lockupSrc = hlLockup.default || hlLockup
const footerLockupSrc = hlLockupFooter.default || hlLockupFooter

export function Logo({subLabel = true, surface = 'page', onClick, homePath = '/'}) {
  const src = surface === 'footer' ? footerLockupSrc : lockupSrc

  const handleClick = event => {
    if (onClick) onClick(event)
    if (typeof window === 'undefined') return
    const path = window.location.pathname.replace(/\/$/, '') || '/'
    // /hlm and /m are this same page, proxied onto homelight.com.
    if (path === '/' || path === '/homelight' || path === '/hlm' || path === '/m') {
      event.preventDefault()
      if (window.location.hash) window.history.pushState(null, '', path)
      window.scrollTo({top: 0, behavior: 'smooth'})
      return
    }
    event.preventDefault()
    try {
      window.sessionStorage.setItem('hlm-scroll-top', '1')
      // Gatsby restores @@scroll|/|initial on the next load of the home page.
      window.sessionStorage.setItem('@@scroll|/|initial', '0')
      window.sessionStorage.setItem('@@scroll|/hlm|initial', '0')
    } catch (e) {}
    window.location.assign(landingPath('/'))
  }

  return (
    <a href={landingPath(homePath)} className="hlm-logo" aria-label="HomeLight Listing Management" onClick={handleClick}>
      <img src={src} alt="HomeLight" />
      {subLabel ? <span className="hlm-logo-sub">Listing Management</span> : null}
    </a>
  )
}
